import { classNames } from 'primereact/utils';

export const CardTailwindThemes = {
  card: {
    root: {
      className: classNames('bg-white shadow-lg rounded-sm'),
    },
    body: 'p-1.5',
    title: 'text-2xl font-bold mb-2',
    subtitle: {
      className: classNames('font-normal mb-2'),
    },
  },
};
